import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { AlertaService } from "../../services/alerta.service";
import { findCompanyAct, findCompanyLogoAct, findUsersOfCompanyAct, loadCompanyByIdAct, loadCompanyLogoByIdAct, loadUsersOfCompanyAct, setViolationsCompanyAct, showMsgErrorAct, updateCompanyAct, updateCompanyLogoAct, updateSuccessCompanyAct, updateSuccessCompanyLogoAct } from "./companies-actions";
import { CompanyService } from "../../services/company.service";

@Injectable()
export class CompanyEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private companyService = inject(CompanyService);
    private alerta = inject(AlertaService);

    findCompanyEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findCompanyAct),
            exhaustMap(action => this.companyService.findCompanyById(action.id)
        .pipe(
            map(company => loadCompanyByIdAct({ company })),
            catchError(error => of(error))
        ))
        )
    );

    /*findCompanyLogoEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findCompanyLogoAct),
            exhaustMap(action => this.companyService.getCompanyLogo(action.id)
        .pipe(
            map(logo => loadCompanyLogoByIdAct({ logo })),
            catchError(error => of(error))
        ))
        )
    );*/
    findCompanyLogoEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(findCompanyLogoAct),
          exhaustMap(action =>
            this.companyService.getCompanyLogo(action.id).pipe(
              map(blob => {
                const logoUrl = URL.createObjectURL(blob);
                return loadCompanyLogoByIdAct({ logoUrl });
              }),
              //catchError(error => of(loadCompanyLogoErrorAct({ error })))
              catchError(error => of(error))
            )
          )
        )
      );


    /*saveCompanyEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveCompanyAct),
            exhaustMap(action => this.companyService.createCompany(action.companyNew)
                .pipe(
                    map(companyNew => saveSuccessCompanyAct({ companyNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsCompanyAct({ companyForm: action.companyNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))
                    
                    )
                )
            )
        )
    );*/

    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });

    /*saveSuccessCompanyEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessCompanyAct),
        tap(() => {
            this.router.navigate(['/signatures']);
            this.alerta.correct("Oferta creado con exito!");
        })
    ), { dispatch: false });*/

    updateCompanyEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateCompanyAct),
            exhaustMap(action => this.companyService.updateAdminCompany(action.companyUpdated.id, action.companyUpdated)
                .pipe(
                    map(companyUpdated => updateSuccessCompanyAct({ companyUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsCompanyAct({ companyForm: action.companyUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessCompanyEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessCompanyAct),
        tap(() => {
            //this.router.navigate(['/adminCompany']);
            this.alerta.correct('Oferta editado con exito!', () => {
                window.location.reload();
            });
            
        })
    ), {dispatch: false});

    updateCompanyLogoEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateCompanyLogoAct),
            exhaustMap(action => this.companyService.updateAdminCompanyLogo(action.id, action.file)
                .pipe(
                    map(companyUpdated => updateSuccessCompanyLogoAct({ companyUpdated })),
                    catchError(error => {
                        /*if(error.status == 400) {
                            return of(setViolationsCompanyAct({ companyForm: action.companyUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }*/
                        return of(showMsgErrorAct({ error }));
                    })
                )
            )
        )
    );

    updateSuccessCompanyLogoEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessCompanyLogoAct),
        tap(() => {
            //this.router.navigate(['/adminCompany']);
            this.alerta.correct('Oferta editado con exito!', () => {
                window.location.reload();
            });
            
        })
    ), {dispatch: false});

    findUsersOfCompanyEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findUsersOfCompanyAct),
            exhaustMap(action => this.companyService.findUsersOfCompany( action.id )
        .pipe(
            map(usersOfCompany => loadUsersOfCompanyAct({ usersOfCompany })),
            catchError(error => of(error))
        ))
        )
    );

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            var nameV: string = item.path.slice(item.path.indexOf('.') + 1);
            nameV = nameV.replace('[', '');
            nameV = nameV.replace(']', '');
            obj[nameV] = item.message;
            return obj;
        }, {});
    };
}